/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateDeviceDetails} from '../api'

export const useMutationUpdateDeviceDetails = createReactQueryMutationHook('updateDeviceDetails', updateDeviceDetails)
